import { Model } from "react3l-common";
import { Field, MomentField } from "react3l-decorators";
import type { Moment } from "moment";
import { AppUser } from "models/AppUser";
import { Project } from "models/Project";
import { Role } from "models/Role";
import { Status } from "models/Status";
import { Position } from "models/Position";
import { Responsibility } from "models/Responsibility";

export class ProjectParticipant extends Model {
  @Field(Number)
  public id?: number;

  @Field(Number)
  public projectId?: number;

  @Field(Number)
  public appUserId?: number;

  @MomentField()
  public startAt?: Moment;

  @MomentField()
  public endAt?: Moment;
  @Field(Number)
  public roleId?: number;

  @Field(Number)
  public statusId?: number;

  @MomentField()
  public createdAt?: Moment;

  @MomentField()
  public updatedAt?: Moment;

  @MomentField()
  public deletedAt?: Moment;

  public appUser?: AppUser;

  public project?: Project;

  public role?: Role;

  public status?: Status;

  public position?: Position;

  public responsibilities?: Responsibility[];
}
